/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-cycle */
import React, { useState, useEffect, useRef } from 'react';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize,
  ExcelExport,
} from '@syncfusion/ej2-react-grids';
import { Link, useNavigate } from 'react-router-dom';

import { DropDownListComponent, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DialogComponent } from '@syncfusion/ej2-react-popups';

import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import axios from 'axios';
import scribeHow from '../data/scribehow.png';
import { useStateContext } from '../contexts/ContextProvider';

import { Header } from '../components';
import { coreBodyEventsGrid, coreVitalEventsGrid, coreTempEventsGrid, reportInvGrid, reportAuditGrid, reportNotificationsGrid } from '../data/dummy';
import './Zackat.css';

const Reports = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let org = localStorage.getItem('organization');
  if (!usr || !org) {
    // Redirect
    navigate('/login?landing=reports');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  org = JSON.parse(org);

  const { zRenderMode, boss } = useStateContext();
  const [associateid, setAssociateId] = useState('');
  const [devceid, setDeviceId] = useState('');
  const editing = { allowDeleting: false, allowEditing: false };
  const { REACT_APP_API_ENDPOINT } = process.env;

  const [corebody, setCoreBody] = useState(false);
  const [oxygen, setOxygen] = useState(false);
  const [hydration, setHydration] = useState(false);
  const [temperature, setTemperature] = useState(false);
  const [respiratory, setRespiratory] = useState(false);
  const [inventory, setInventory] = useState(false);
  const [associates, setAssociates] = useState(false);
  const [audit, setAudit] = useState(false);
  const [auditDialog, setAuditDialog] = useState(true);
  const [auditid, setAuditId] = useState('');
  const [auditData, setAuditData] = useState([]);
  const [notifications, setNotifications] = useState(false);
  const [selectedReport, setReport] = useState('');
  const [selectedMeasurement, setMeasurement] = useState('');
  const [tableData, setTableData] = useState([]);
  const excel = { text: 'Excel Export', tooltipText: 'Export', prefixIcon: 'e-export-excel', id: 'excel', disabled: false };
  const aud = { text: 'Audit', tooltipText: 'Audit', prefixIcon: 'e-full-screen', id: 'aud', visible: auditid !== '' && boss };
  const toolbarOptions = [excel, aud, 'Search'];
  const measurements = [
    'CoreBody',
    'Temperature',
    'HeartRate',
    'Respiratory',
    'Oxygen',
  ];
  const header = () => (
    <div><h1>Audit {auditid} </h1></div>
  );

  useEffect(() => {
    const auditReport = async () => {
      if (auditid && auditid.length > 0) {
        axios({
          url: `${REACT_APP_API_ENDPOINT}/reports?report=audit&_id=${usr._id}&organizationid=${org.id}&auditid=${auditid}`,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            setAuditData(response.data);
            setAuditDialog(!auditDialog);
          })
          .catch(() => {
          });
      }
    };
    auditReport();
  }, [auditid]);

  const auditTemplate = () => {
    console.log('What is it', auditData.audit);
    return (
      <div className="pt-2 relative mx-auto text-gray-600 zackat-divalh">
        <pre>{JSON.stringify(auditData.audit, null, 2)}</pre>
      </div>
    );
  };

  const auditbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        setAuditDialog(!auditDialog);
        setAuditId('');
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];

  const minDate = new Date('10/01/2024 00:00 AM');
  let maxDate = new Date();
  maxDate = new Date(maxDate.setDate(maxDate.getDate() + 1));
  let fromDate = new Date();
  fromDate = new Date(fromDate.setDate(maxDate.getDate() - 1));
  const toDate = new Date();
  const [from, setFrom] = useState(fromDate.getTime() / 1000);
  const [to, setTo] = useState(maxDate.getTime() / 1000);
  const [fromHere, setFromHere] = useState(fromDate);
  const [toHere, setToHere] = useState(toDate);
  const [battery, setBattery] = useState('20');
  const [nameOrDevice, setNameOrDevice] = useState(null);
  const grid = useRef(null);
  function measurementSelect(e) {
    setMeasurement(e.value);
  }
  async function reportSelect(e) {
    setTableData([]);
    if (notifications && e.value !== 'Notifications') {
      setNotifications(false);
    }
    setReport(e.value);
    if (e.value === 'Core Measurements') {
      setCoreBody(true);
    } else {
      setCoreBody(false);
    }
    if (e.value === 'Low Battery') {
      setInventory(true);
    } else {
      setInventory(false);
    }
    if (e.value === 'Notifications') {
      setNotifications(true);
      axios({
        url: `${REACT_APP_API_ENDPOINT}/reports?report=notifications&_id=${usr._id}&organizationid=${org.id}&from=${from}&to=${to}`,
        method: 'get',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (response.data && response.data.notifications) {
            setTableData(response.data.notifications);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setAssociates(false);
    }
    if (e.value === 'Audit') {
      setAudit(true);
      axios({
        url: `${REACT_APP_API_ENDPOINT}/reports?report=audit&_id=${usr._id}&organizationid=${org.id}&from=${from}&to=${to}`,
        method: 'get',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          setTableData(response.data.audit);
        })
        .catch(() => {
        });
    } else {
      setAudit(false);
    }
  }
  function setDesiredBattery(e) {
    if (e && e.value && e.value.length >= 2) {
      setBattery(e.value);
    }
  }

  useEffect(() => {
    const batteryReport = async () => {
      if (battery && battery.length >= 2) {
        axios({
          url: `${REACT_APP_API_ENDPOINT}/reports?report=lowbattery&_id=${usr._id}&from=${from}&to=${to}&battery=${battery}`,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            setTableData(response.data.inventory);
          })
          .catch(() => {
          });
      }
    };
    batteryReport();
    return () => {
      setBattery('20');
      setTableData([]);
    };
  }, [battery, inventory, toHere, fromHere]);
  async function deviceSelect(e) {
    let stringData = '';
    for (let i = 0; i < e.value.length; i += 1) {
      stringData += `&devices=${e.value[i]}`;
    }
    setDeviceId(e.value);
    axios({
      url: `${REACT_APP_API_ENDPOINT}/reports?report=lowbattery&_id=${usr._id}${stringData}&from=${from}&to=${to}&battery={batt}`,
      method: 'get',
      headers: {
        Authorization: `JWTToken ${usr.token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        setTableData(response.data.inventory);
      })
      .catch(() => {
      });
  }
  async function associateSelect(e) {
    if (!e || !e.value) {
      return;
    }
    setAssociateId(e.value);
    axios({
      url: `${REACT_APP_API_ENDPOINT}/reports?report=corebody&associateid=${e.value}&_id=${usr._id}&from=${from}&to=${to}&measurement=${selectedMeasurement}`,
      method: 'get',
      headers: {
        Authorization: `JWTToken ${usr.token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (selectedMeasurement === 'CoreBody') {
          setTableData(response.data.coreBody);
        } else {
          setTableData(response.data.coreVitals);
        }
      })
      .catch(() => {
      });
  }
  useEffect(() => {
    const getCoreBody = async () => {
      if (corebody && nameOrDevice && nameOrDevice.length > 0) {
        axios({
          url: `${REACT_APP_API_ENDPOINT}/reports?report=corebody&name=${nameOrDevice}&_id=${usr._id}&from=${from}&to=${to}&measurement=${selectedMeasurement}`,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (selectedMeasurement === 'CoreBody') {
              setTableData(response.data.coreBody);
            } else {
              setTableData(response.data.coreVitals);
            }
          })
          .catch(() => {
          });
      }
    };
    getCoreBody();
  }, [nameOrDevice, toHere, fromHere, selectedMeasurement]);

  function dateChanged(e) {
    if (!e || !e.value) {
      return;
    }
    const d1 = new Date(e.value);
    if (e.target.id === 'fromdate') {
      setFrom(d1.getTime() / 1000);
      setFromHere(d1);
    }
    if (e.target.id === 'todate') {
      setTo(d1.getTime() / 1000);
      setToHere(d1);
    }
    if (selectedReport === 'Audit') {
      reportSelect({ value: 'Audit' });
    } else if (selectedReport === 'Core Measurements') {
      associateSelect({ value: associateid });
    } else if (selectedReport === 'Notifications') {
      reportSelect({ value: 'Notifications' });
    }
    if (grid && grid.current) {
      grid.current.refresh();
    }
  }
  const fields = { value: 'value', text: 'text' };
  const associateFields = { text: 'name', value: '_id' };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const selectedOrg = JSON.parse(localStorage.getItem('organization'));
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    usr.report = 'reports';
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/reports?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();

      // set state when the data received
      setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, []);

  const clickHandler = (args) => {
    if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `ExcelExport_${selectedReport}_${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(properties);
    } else if (grid && grid.current && args.item.properties.text === 'Audit') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (selectedRecords && selectedRecords.length === 1) {
        setAuditId(selectedRecords[0]._id);
      }
    }
  };
  if (loading) {
    return <p>Loading... </p>;
  }
  const FilterOptions = {
    type: 'Menu',
  };
  const measurementOptions = () => (
    <div className="flex">
      <span className="e-icons e-filter-1" /><DropDownListComponent id="ddlmelement" dataSource={measurements} placeholder="Select a measurement" value={selectedMeasurement} onChange={measurementSelect} />
    </div>
  );
  const reportOptions = () => (
    <div className="flex">
      <span className="e-icons e-freeze-column" /><DropDownListComponent id="ddlelement" dataSource={data.reports} placeholder="Select a report" value={selectedReport} onChange={reportSelect} />
    </div>
  );
  const fromDateOptions = () => (
    <div className="flex">
      <span className="e-icons e-timeline-month" />{(corebody || audit || notifications || associates || inventory) && <DateTimePickerComponent id="fromdate" onChange={dateChanged} placeholder="Select From Date/Time" value={fromHere} min={minDate} max={maxDate} />}
    </div>
  );
  const toDateOptions = () => (
    <div className="flex">
      <span className="e-icons e-timeline-month" />{(corebody || audit || notifications || associates || inventory) && <DateTimePickerComponent id="todate" onChange={dateChanged} placeholder="Select To Date/Time" value={toHere} min={minDate} max={maxDate} />}
    </div>
  );
  const deviceOptions = () => (
    <div className="flex">
      {/*
      <span className="e-icons e-bring-to-front" />{inventory && <MultiSelectComponent id="deviceSelect" dataSource={data.devices} fields={fields} width={350} onChange={deviceSelect} value={devceid} placeholder="Select device(s)" />}
      */}
      {inventory && (
      <div className="mt-2 e-mygrid">
        <TextBoxComponent className="mt-2" placeholder="Level" value={battery} title="battery level " floatLabelType="Auto" onChange={(e) => { setDesiredBattery(e); }} />
      </div>
      )}
    </div>
  );

  const searchThis = (args) => {
    const search = document.getElementById('associatesearch');
    if (search && search.value && search.value.length > 0) {
      setNameOrDevice(search.value);
    }
  };
  const handleKeyDown = (e) => {
    // Check if the pressed key is "Enter"
    if (e.key === 'Enter') {
      // Prevent the default form submission behavior
      e.preventDefault();
      // Perform your search or submission logic here
      searchThis(e);
      // Optional: Clear the textbox after searching
      // setValue('');
    }
  };

  const inputStyle = { width: '400px', display: 'inline-block', float: 'right' };
  const searchComponent = () => (
    <div className="pt-2 relative mx-auto text-gray-600">
      <input
        className="border-2 border-gray-300 bg-white h-10 px-5 pr-16 rounded-lg text-sm focus:outline-none searchtext"
        type="search"
        name="search"
        style={inputStyle}
        id="associatesearch"
        title="associate name or device"
        defaultValue={nameOrDevice}
        placeholder="Search associate, device or case sensitive name"
        onKeyDown={handleKeyDown}
      />
      <button type="button" aria-label="Search" title="" className="absolute right-0 top-0 mt-5 mr-4" onClick={searchThis}>
        <svg
          className="text-gray-600 h-4 w-4 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 56.966 56.966"
          xmlSpace="preserve"
          width="512px"
          height="512px"
        >
          <path
            d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"
          />
        </svg>
      </button>
    </div>
  );

  const associateOptions = () => (
    <div className="flex">
      {/*
      <span className="e-icons e-people" />{corebody && associateid !== '' && <DropDownListComponent id="associateSelect" dataSource={data.associates} fields={associateFields} width={350} onChange={associateSelect} value={associateid} placeholder="Select Inventory (Associate)" />}
      */}
    </div>
  );
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div">
      <div className="flex">
        <Link
          className="my-link"
          to="https://scribehow.com/viewer/Select_Low_Battery_Report_and_Update_Level__TVApiwmJRWWc-ORjmCMEug"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Dashboards" title={`Reports : ${selectedReport}`} />
      </div>
      <ToolbarComponent id="toolbar">
        <ItemsDirective>
          <ItemDirective template={reportOptions} />
          <ItemDirective type="Separator" />
          {corebody && <ItemDirective template={measurementOptions} />}
          <ItemDirective type="Separator" />
          {(corebody || audit || notifications || associates || inventory) && <ItemDirective template={fromDateOptions} />}
          {(corebody || audit || notifications || associates || inventory) && <ItemDirective type="Separator" />}
          {(corebody || audit || notifications || associates || inventory) && <ItemDirective template={toDateOptions} />}
          {(corebody || audit || notifications || associates || inventory) && <ItemDirective type="Separator" />}
          {inventory && <ItemDirective template={deviceOptions} />}
          {inventory && <ItemDirective type="Separator" />}
          {corebody && <ItemDirective template={associateOptions} />}
          {corebody && <ItemDirective text="Search" template={searchComponent} style={{ float: 'right !important' }} />}
        </ItemsDirective>
      </ToolbarComponent>

      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            {tableData && tableData.length !== 0 && (corebody || inventory || associates || audit || notifications) && (
            <GridComponent
              dataSource={tableData}
              width="auto"
              allowPaging
              allowSorting
              editSettings={editing}
              toolbar={toolbarOptions}
              toolbarClick={clickHandler}
              enableHover={false}
              pageSettings={{ pageSize: 30 }}
              allowResizing
              allowFiltering
              filterSettings={FilterOptions}
              allowExcelExport
              showColumnChooser
              allowTextWrap
              ref={grid}
              enableAdaptiveUI
              rowRenderingMode={zRenderMode}
              enableAltRow
            >
              <ColumnsDirective>
                {corebody && selectedMeasurement === 'CoreBody' && coreBodyEventsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {corebody && selectedMeasurement === 'Temperature' && coreTempEventsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {corebody && selectedMeasurement === 'HeartRate' && coreVitalEventsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {corebody && selectedMeasurement === 'Respiratory' && coreVitalEventsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {corebody && selectedMeasurement === 'Oxygen' && coreVitalEventsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {inventory && reportInvGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {notifications && reportNotificationsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {audit && reportAuditGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
              </ColumnsDirective>
              <Inject services={[Search, Page, Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize, ExcelExport]} />
            </GridComponent>
            )}
          </div>
        </div>
      </div>
      {!auditDialog && (
        <DialogComponent
          header={header}
          content={auditTemplate}
          buttons={auditbuttons}
          width="55%"
          height="85%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => {
            setAuditDialog(!auditDialog);
            setAuditId('');
          }}
          close={() => {
            setAuditDialog(!auditDialog);
            setAuditId('');
          }}
        />
      )}

    </div>
  );
};
export default Reports;
